<cm-status-indicator-step
    *ngIf="!stepWithoutStatus.includes(stepType)"
    class="status-indicator"
    [status]="statusColor"
    [tooltip]="tooltip"
>
</cm-status-indicator-step>
<cm-icon class="icon" [name]="iconName"></cm-icon>
